import * as React from "react";
import { DockPanel } from "../core/core-widgets/panels/DockPanel";
import { SelectFeature, SelectFeatureDispatchProps } from "./components/SelectFeature";
import { ChangeValidityInterval, ChangeValidityIntervalProps } from "./components/ChangeValidityInterval";
import { DrawingTool, DrawingToolDispatchProps } from "./components/Drawing/DrawingTool";
import { FeatureActions, FeatureActionsDispatchProps } from "./components/FeatureActions";
import { FeatureFilter, FeatureFilterDispatchProps } from "./components/FeatureFilter";
import { OtherActions, OtherActionsDispatchProps } from "./components/OtherActions";
import { IntlContextProvider } from "../core/core-widgets/contexts/IntlContext";
import { Point } from "../rootState";
import { ContentContainer } from "../core/core-widgets/surfaces/ContentContainer/ContentContainer";
import { ConnectedExportMap } from "../exportMap/ConnectedExportMap";
import { ExportMapCanvas } from "../exportMapToPdf/ExportMapCanvas";
import AltitudeRangeModifier, {
    AltitudeRangeModifierDispatchProps,
    UnitsOfMeasurement,
} from "../altitudeModifier/AltitudeRangeModifier";

export interface DevelopmentToolsStateProps {
    enabled: boolean;
    currentZoomLevel: number;
    lowerLimit: number;
    upperLimit: number;
    units: UnitsOfMeasurement;
    drawingToolEnabled: boolean;
    points?: Point[];
}

export type DevelopmentToolsDispatchProps = SelectFeatureDispatchProps &
    ChangeValidityIntervalProps &
    DrawingToolDispatchProps &
    FeatureActionsDispatchProps &
    FeatureFilterDispatchProps &
    OtherActionsDispatchProps &
    AltitudeRangeModifierDispatchProps;

export const DevelopmentTools = (props: DevelopmentToolsStateProps & DevelopmentToolsDispatchProps) => {
    const {
        enabled,
        currentZoomLevel,
        drawingToolEnabled,
        points,
        lowerLimit,
        upperLimit,
        units,
        onFeaturesSelected,
        onChangeValidityInterval,
        onDrawModeChange,
        onEditFeature,
        onViewFeature,
        onFilterChange,
        onReloadMap,
        onChangeMinValue,
        onChangeMaxValue,
        onChangeUnits,
    } = props;

    if (!enabled) return null;

    return (
        <IntlContextProvider>
            <DockPanel title={"Development Tools"} open position={"right"} size={400} dockStyle={{ height: "96.85%" }}>
                <ContentContainer>
                    <SelectFeature onFeaturesSelected={onFeaturesSelected} />
                    <ChangeValidityInterval onChangeValidityInterval={onChangeValidityInterval} />
                    <DrawingTool enabled={drawingToolEnabled} points={points} onDrawModeChange={onDrawModeChange} />
                    <FeatureActions onEditFeature={onEditFeature} onViewFeature={onViewFeature} />
                    <FeatureFilter onFilterChange={onFilterChange} />
                    <OtherActions currentZoomLevel={currentZoomLevel} onReloadMap={onReloadMap} />
                    <AltitudeRangeModifier
                        onChangeMaxValue={onChangeMaxValue}
                        onChangeMinValue={onChangeMinValue}
                        onChangeUnits={onChangeUnits}
                        lowerLimit={lowerLimit}
                        upperLimit={upperLimit}
                        units={units}
                    />
                    <ExportMapCanvas />
                    <ConnectedExportMap />
                </ContentContainer>
            </DockPanel>
        </IntlContextProvider>
    );
};
